import { configureStore } from '@reduxjs/toolkit';
import aplicacaoReducer from '../features/aplicacaoSlice';

export const store = configureStore({
  reducer: {
    aplicacoes: aplicacaoReducer,
  },
});
